import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Form, Button, Card, Row, Col, Toast } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { getUserDetail, login } from "../../api/authApi";
//import logoImage from "../../assets/images/logoimage.png";
import logoImage from "../../assets/images/DailyPostHub.png";
import { CompanyName } from "../../config/staticArray";
import ToastFile from "../../utils/ToastFile";

const Login = () => {
  const navigate = useNavigate();

  const onSubmit = (data) => {
    let payload = { email:data.email, password:data.password };
        login(payload).then((res) => {
          if(res?.data?.isSuccess){
            localStorage.setItem("token", res.data.data.token);
            localStorage.setItem("user", JSON.stringify(res.data.data.user));
            navigate("/dashboard");
          }else{
            ToastFile(res?.data?.message || "Login failed. Please try again.", 'error');
          }
        });
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  return (
    <Container
      fluid
      className="d-flex align-items-center justify-content-center min-vh-100 bg-light px-3"
    >
      <Row className="w-100 justify-content-center">
        <Col xs={12} sm={10} md={8} lg={5} xl={4}>
          <Card className="p-4 shadow rounded-4">
            <div className="text-center mb-4">
              <img
                src={logoImage}
                alt="Company Logo"
                style={{ width: "100%", height: "auto" }}
              />
              {/* <h5 className="mt-2 mb-0 fw-bold text-primary">{CompanyName}</h5>
              <h6 className="fw-bold text-primary">Contractor Management System</h6> */}
            </div>

            <h5 className="fw-bold">Sign In</h5>
            <p className="text-muted mb-3">
              Please enter your email and password.
            </p>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  {...register("email", { required: true })}
                  isInvalid={errors.email}
                />
              </Form.Group>
              <Form.Group className="mb-5">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  {...register("password", { required: true })}
                  isInvalid={errors.password}
                />
              </Form.Group>
             {/* <div className="d-flex justify-content-end mb-3">
                <a
                  href="#"
                  className="text-primary text-decoration-none fw-semibold"
                >
                  Forgot Password?
                </a>
              </div>

              <Form.Group className="d-flex align-items-center justify-content-between mb-3">
                <Form.Check type="switch" id="rememberMe" label="Remember me" />
              </Form.Group> */}
  

              <Button variant="primary" className="w-100 fw-bold" type="submit">
                SIGN IN
              </Button>
           
            </Form>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
